export default {"src":"/_next/static/media/celebrate.a263d9da.svg","height":32,"width":32,"blurWidth":0,"blurHeight":0};